import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const HeartFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12 20.58C6.8 16.8 3.38 13.38 3.38 9.64C3.38 6.88 5.5 4.58 8.36 4.58C9.9 4.58 11.26 5.36 12 6.7C12.74 5.36 14.1 4.58 15.64 4.58C18.5 4.58 20.62 6.88 20.62 9.64C20.62 13.38 17.2 16.8 12 20.58Z" />
    </SvgIcon>
  );
});
